import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=3a7b5fc0&scoped=true&"
import script from "./Load.vue?vue&type=script&lang=js&"
export * from "./Load.vue?vue&type=script&lang=js&"
import style0 from "./Load.vue?vue&type=style&index=0&id=3a7b5fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b5fc0",
  null
  
)

export default component.exports